import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import { computed, observable } from 'mobx';
import createHtmlLink from '@src/utils/create-html-link';

class OpenBetaHighlightsStore extends BaseStore {
  @observable
  qrcodeList = [
    {
      img: require('./images/qrcode-gzh.png'),
      titleImg: require('./images/qrcode-title-gzh.png'),
      title: '微信公众号'
    },
    {
      img: require('./images/qrcode-gj.png'),
      titleImg: require('./images/qrcode-title-gj.png'),
      title: '微信管家'
    },
    {
      img: require('./images/qrcode-dy.png'),
      titleImg: require('./images/qrcode-title-dy.png'),
      title: '官方抖音',
      link: 'https://v.douyin.com/UjlMm0J8zxo/'
    },
    {
      img: require('./images/qrcode-wb.png'),
      titleImg: require('./images/qrcode-title-wb.png'),
      title: '手游微博',
      link: 'https://weibo.com/u/7904323368'
    }
  ];
  @observable realIndex = 0;
  @observable prize_code = '132486';
  @computed
  get params() {
    const that = this;
    return {
      loop: true,
      on: {
        init: function() {
          that.swiperRef = this;
        },
        slideChangeTransitionEnd: function() {
          that.realIndex = this.realIndex;
        }
      }
    };
  }
  swiperRef = null;

  changeSwiper = type => {
    if (type === 'prev') {
      this.swiperRef.slidePrev();
    } else if (type === 'next') {
      this.swiperRef.slideNext();
    } else {
      this.swiperRef.slideTo(type + 1);
    }
  };

  showFooter = () => {};

  handleLink = item => {
    if (!item.link) {
      return;
    }
    const link = createHtmlLink(item.link);
    link.href = item.link;
    link.target = '_blank';
    link.click();
  };

  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  use() {
    super.use();

    useMount(async () => {});
  }
}

export default OpenBetaHighlightsStore;
